import { render, staticRenderFns } from "./VisitPage.vue?vue&type=template&id=5bff04ff&scoped=true"
import script from "./VisitPage.vue?vue&type=script&lang=js"
export * from "./VisitPage.vue?vue&type=script&lang=js"
import style0 from "./VisitPage.vue?vue&type=style&index=0&id=5bff04ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff04ff",
  null
  
)

export default component.exports